export default function Navbar({ currentPage, setCurrentPage }) {
  return (
    <div className="fixed-top mt-4 d-flex justify-content-center" style={{ zIndex: 1000 }}>
      <nav className="navbar navbar-expand-md py-2 px-4 blur-nav rounded-pill" style={{ width: "90%", maxWidth: "900px" }}>
        <span 
          className="navbar-brand text-white fw-bold fs-6 m-0" 
          style={{ cursor: "pointer", letterSpacing: "-0.04em" }}
          onClick={() => setCurrentPage("home")}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="me-2 d-inline-block align-text-top">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
          </svg>
          TapSecureX
        </span>
        
        <button className="navbar-toggler border-0 shadow-none p-0 ms-auto" type="button" data-bs-toggle="collapse" data-bs-target="#mainNav">
          <i className="bi bi-list text-white fs-3"></i>
        </button>

        <div className="collapse navbar-collapse" id="mainNav">
          <ul className="navbar-nav ms-auto align-items-md-center gap-3 mt-3 mt-md-0">
            <li className="nav-item">
              <span className={`nav-link ${currentPage === 'home' ? 'active' : ''}`} onClick={() => setCurrentPage("home")}>Overview</span>
            </li>
            <li className="nav-item">
              <span className={`nav-link ${currentPage === 'about' ? 'active' : ''}`} onClick={() => setCurrentPage("about")}>Engine</span>
            </li>
            <li className="nav-item">
              <span className={`nav-link ${currentPage === 'privacy' ? 'active' : ''}`} onClick={() => setCurrentPage("privacy")}>Privacy</span>
            </li>
            <li className="nav-item ms-md-3">
              <span className="btn btn-secondary btn-sm px-4 py-2 rounded-pill w-100 font-mono" onClick={() => setCurrentPage("contact")}>Support</span>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
}